// this file is auto-generated via GenerateViewsFile.php 
window.viewFunctions = {};
window.viewFunctions['js/view/ASMR/ASMR.jsx'] = (...args) => {
	import('./ASMR/ASMR.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Actor/LandingPageHeader.jsx'] = (...args) => {
	import('./Actor/LandingPageHeader.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Actor/LandingPageVideosTile.jsx'] = (...args) => {
	import('./Actor/LandingPageVideosTile.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Actor/LandingPageRestrictedArea.jsx'] = (...args) => {
	import('./Actor/LandingPageRestrictedArea.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Actor/ProfileHeaderButtons.jsx'] = (...args) => {
	import('./Actor/ProfileHeaderButtons.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Actor/ActorProfile.jsx'] = (...args) => {
	import('./Actor/ActorProfile.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Cams.jsx'] = (...args) => {
	import('./Cams.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Cams/CamsNextDoor.jsx'] = (...args) => {
	import('./Cams/CamsNextDoor.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Cams/NewGirls.jsx'] = (...args) => {
	import('./Cams/NewGirls.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Categories/CategoriesHeader.jsx'] = (...args) => {
	import('./Categories/CategoriesHeader.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Categories/CategoriesOverview.jsx'] = (...args) => {
	import('./Categories/CategoriesOverview.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Categories/CategoriesTopCams.jsx'] = (...args) => {
	import('./Categories/CategoriesTopCams.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Cookies.js'] = (...args) => {
	import('./Cookies.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Conversion.jsx'] = (...args) => {
	import('./Conversion.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/ContestOverview.jsx'] = (...args) => {
	import('./ContestOverview.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/ContestDetails.jsx'] = (...args) => {
	import('./ContestDetails.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/DataProtection.jsx'] = (...args) => {
	import('./DataProtection.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/DataProtectionBar.jsx'] = (...args) => {
	import('./DataProtectionBar.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/IndexFooter.jsx'] = (...args) => {
	import('./IndexFooter.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/IndexNavbar.js'] = (...args) => {
	import('./IndexNavbar.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/IndexMessenger.jsx'] = (...args) => {
	import('./IndexMessenger.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/IndexMessengerClick.js'] = (...args) => {
	import('./IndexMessengerClick.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Loader/Loader.jsx'] = (...args) => {
	import('./Loader/Loader.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Messenger.jsx'] = (...args) => {
	import('./Messenger.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/ModalPornmeConversion.jsx'] = (...args) => {
	import('./ModalPornmeConversion.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/ModalPornmeMigration.jsx'] = (...args) => {
	import('./ModalPornmeMigration.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/MyVisitX/FavoriteActors.jsx'] = (...args) => {
	import('./MyVisitX/FavoriteActors.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/MyVisitX/FavoriteVideos.jsx'] = (...args) => {
	import('./MyVisitX/FavoriteVideos.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/MyVisitX/GuestProfile.jsx'] = (...args) => {
	import('./MyVisitX/GuestProfile.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/MyVisitX/Benefits.jsx'] = (...args) => {
	import('./MyVisitX/Benefits.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/MyVisitX/Spinwheel.jsx'] = (...args) => {
	import('./MyVisitX/Spinwheel.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/MyVisitX/Mediathek.jsx'] = (...args) => {
	import('./MyVisitX/Mediathek.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/MyVisitX/Achievement.jsx'] = (...args) => {
	import('./MyVisitX/Achievement.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/MyVisitX/MyVideoChats.jsx'] = (...args) => {
	import('./MyVisitX/MyVideoChats.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/NavBar.jsx'] = (...args) => {
	import('./NavBar.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/NewsletterUnsubscribe.jsx'] = (...args) => {
	import('./NewsletterUnsubscribe.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Pagination.jsx'] = (...args) => {
	import('./Pagination.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/PjaxBase.js'] = (...args) => {
	import('./PjaxBase.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Plain.js'] = (...args) => {
	import('./Plain.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Restricted.js'] = (...args) => {
	import('./Restricted.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Special/Goldrush.jsx'] = (...args) => {
	import('./Special/Goldrush.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Special/AdventCalendar/AdventCalendar.jsx'] = (...args) => {
	import('./Special/AdventCalendar/AdventCalendar.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Special/TwentyFiveYears.jsx'] = (...args) => {
	import('./Special/TwentyFiveYears.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Special/CumOn.jsx'] = (...args) => {
	import('./Special/CumOn.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Special/VXCalendar/VXCalendar.jsx'] = (...args) => {
	import('./Special/VXCalendar/VXCalendar.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Special/Easter/Easter.jsx'] = (...args) => {
	import('./Special/Easter/Easter.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Special/SpecialEvents.js'] = (...args) => {
	import('./Special/SpecialEvents.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Special/KickIt.jsx'] = (...args) => {
	import('./Special/KickIt.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Special/Lexy360.jsx'] = (...args) => {
	import('./Special/Lexy360.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Special/RoxxRacing.jsx'] = (...args) => {
	import('./Special/RoxxRacing.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Special/SlotMachine.jsx'] = (...args) => {
	import('./Special/SlotMachine.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Special/WiesnShooting.jsx'] = (...args) => {
	import('./Special/WiesnShooting.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Special/WetAndWild.jsx'] = (...args) => {
	import('./Special/WetAndWild.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Special/WiesnBude.jsx'] = (...args) => {
	import('./Special/WiesnBude.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Special/VRPorn.jsx'] = (...args) => {
	import('./Special/VRPorn.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Magazine/V2/Home.jsx'] = (...args) => {
	import('./Magazine/V2/Home.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Magazine/V2/Archives.jsx'] = (...args) => {
	import('./Magazine/V2/Archives.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/StatusBar.jsx'] = (...args) => {
	import('./StatusBar.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/CookieBlockedBar.jsx'] = (...args) => {
	import('./CookieBlockedBar.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/SupportChat.js'] = (...args) => {
	import('./SupportChat.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Survey.jsx'] = (...args) => {
	import('./Survey.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Teaser.jsx'] = (...args) => {
	import('./Teaser.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Test/TestPLA.jsx'] = (...args) => {
	import('./Test/TestPLA.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Test/TestNR.js'] = (...args) => {
	import('./Test/TestNR.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Test/TestJMU.jsx'] = (...args) => {
	import('./Test/TestJMU.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Test/TestVXPay.js'] = (...args) => {
	import('./Test/TestVXPay.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Test/TestWebPush.js'] = (...args) => {
	import('./Test/TestWebPush.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Test/TestBonus365.jsx'] = (...args) => {
	import('./Test/TestBonus365.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Test/VXTeaserPreview.jsx'] = (...args) => {
	import('./Test/VXTeaserPreview.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/TV/MediaSingle.js'] = (...args) => {
	import('./TV/MediaSingle.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/TV/SuggestVideo.jsx'] = (...args) => {
	import('./TV/SuggestVideo.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/TV/MediaViewer.jsx'] = (...args) => {
	import('./TV/MediaViewer.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/TV/Mediathek.js'] = (...args) => {
	import('./TV/Mediathek.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/TV/VXPayHooks.jsx'] = (...args) => {
	import('./TV/VXPayHooks.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/SimpleElements/VXButton.jsx'] = (...args) => {
	import('./SimpleElements/VXButton.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/WelcomeBanner.jsx'] = (...args) => {
	import('./WelcomeBanner.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/SimpleElements/VideochatMessengerButton.jsx'] = (...args) => {
	import('./SimpleElements/VideochatMessengerButton.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Magazine/V2/BlogArticle.jsx'] = (...args) => {
	import('./Magazine/V2/BlogArticle.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/WebPushSubscribe.jsx'] = (...args) => {
	import('./WebPushSubscribe.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/LangRedirectPopup.jsx'] = (...args) => {
	import('./LangRedirectPopup.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Video/IndexVideo.jsx'] = (...args) => {
	import('./Video/IndexVideo.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Video/VideoSub.jsx'] = (...args) => {
	import('./Video/VideoSub.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Video/VideoSearch.jsx'] = (...args) => {
	import('./Video/VideoSearch.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Video/VideoStars.jsx'] = (...args) => {
	import('./Video/VideoStars.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Banner.jsx'] = (...args) => {
	import('./Banner.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Homepage/IndexHomepage.jsx'] = (...args) => {
	import('./Homepage/IndexHomepage.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/NotFound.jsx'] = (...args) => {
	import('./NotFound.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Search.jsx'] = (...args) => {
	import('./Search.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/SearchResults.jsx'] = (...args) => {
	import('./SearchResults.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/DailyBonus/DailyBonusIndex.jsx'] = (...args) => {
	import('./DailyBonus/DailyBonusIndex.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/FreeChat.jsx'] = (...args) => {
	import('./FreeChat.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Lindemann.jsx'] = (...args) => {
	import('./Lindemann.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/VIPClub.jsx'] = (...args) => {
	import('./VIPClub.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/VIP30.jsx'] = (...args) => {
	import('./VIP30.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/ClashOfCams.jsx'] = (...args) => {
	import('./ClashOfCams.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/UserActivities.jsx'] = (...args) => {
	import('./UserActivities.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/CamShows.jsx'] = (...args) => {
	import('./CamShows.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/TermsOfService.jsx'] = (...args) => {
	import('./TermsOfService.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/ComplianceNotice2257.jsx'] = (...args) => {
	import('./ComplianceNotice2257.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Imprint.jsx'] = (...args) => {
	import('./Imprint.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Feed.jsx'] = (...args) => {
	import('./Feed.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/FloatingNotifications.jsx'] = (...args) => {
	import('./FloatingNotifications.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Showcase.jsx'] = (...args) => {
	import('./Showcase.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Soft.jsx'] = (...args) => {
	import('./Soft.jsx').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Rosenrausch.jsx'] = (...args) => {
	import('./Rosenrausch.jsx').then((view) => view.run(...args));
};
